export const PROFILE_PHOTO_KEY = "usuarioFoto";
export const PROFILE_UPDATED_EVENT = "zuno:profile-updated";

export function getCachedProfilePhoto() {
  return localStorage.getItem(PROFILE_PHOTO_KEY) || "";
}

export function setCachedProfilePhoto(photoURL) {
  const normalized = photoURL || "";
  localStorage.setItem(PROFILE_PHOTO_KEY, normalized);
  window.dispatchEvent(new CustomEvent(PROFILE_UPDATED_EVENT, {
    detail: { photoURL: normalized },
  }));
  return normalized;
}

export function subscribeToProfilePhoto(callback) {
  const onProfileUpdated = (event) => callback(event.detail?.photoURL || getCachedProfilePhoto());
  const onStorage = (event) => {
    if (event.key === PROFILE_PHOTO_KEY) callback(event.newValue || "");
  };
  window.addEventListener(PROFILE_UPDATED_EVENT, onProfileUpdated);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(PROFILE_UPDATED_EVENT, onProfileUpdated);
    window.removeEventListener("storage", onStorage);
  };
}
